(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zv-footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const trigger=event.target.closest('[data-zv-dialog]');if(trigger){const dialog=document.getElementById(trigger.dataset.zvDialog);if(dialog&&!dialog.open)dialog.showModal();}if(event.target.matches('.zv-info-dialog')){const box=event.target.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)event.target.close();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zv-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{document.querySelectorAll('.zv-popover[open]').forEach(el=>{if(!el.contains(event.target)||event.target.closest('a'))el.removeAttribute('open')})});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.zv-popover[open]').forEach(el=>{el.removeAttribute('open');el.querySelector('summary').focus()})}});
function zvRenderCart(count){const bag=document.querySelector('.zv-bag');const badge=bag?.querySelector('[data-zv-cart-count]');if(!badge||!Number.isFinite(count))return;badge.textContent=String(count);badge.hidden=count===0;bag.setAttribute('aria-label',bag.dataset.zvLabel+(count>0?': '+count:''));}
function zvRefreshCart(){const url=document.querySelector('.zv-bag')?.getAttribute('href');if(url)fetch(url+'.js',{headers:{Accept:'application/json'}}).then(response=>response.ok?response.json():null).then(cart=>{if(cart)zvRenderCart(cart.item_count)}).catch(()=>{});}
document.addEventListener('shopify:cart:lines-update',event=>{event.promise?.then(({cart})=>{if(cart)zvRenderCart(cart.totalQuantity);else zvRefreshCart();}).catch(()=>{});});
window.addEventListener('pageshow',zvRefreshCart);document.addEventListener('shopify:section:load',zvRefreshCart);zvRefreshCart();

  } catch(e) { console.error(e); }
})();
})();
